import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    ResponsiveContainer,
    Tooltip,
    CartesianGrid,
  } from "recharts";
  
  const Referrers = ({ referrer }) => {
    const total = referrer.reduce((acc, cur) => acc + cur.total, 0);
  
    return (
      <div className="bg-white rounded-2xl shadow p-4">
        <p className="text-sm text-gray-500 mb-2 text-center">Origem do Tráfego</p>
        <div className="h-[250px]">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={referrer}
              layout="vertical"
              margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis type="number" allowDecimals={false} />
              <YAxis dataKey="origem" type="category" width={100} />
              <Tooltip formatter={(v) => [`${v} visitas`, "Total"]} />
              <Bar dataKey="total" fill="#3B82F6" radius={[0, 8, 8, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    );
  };
  
  export default Referrers;
  